import React, { Component } from "react";
import Header from './Header'
import {getBroker, getTowers} from '../services/BinderDropService'
import Logo_Industry from "../img/ico/round_industry.png"
import { Doughnut, defaults, Bar } from 'react-chartjs-2';
import {SetChartDefaults, AddRecent} from '../util/Helper'
import InfoCard from "../components/InfoCard";
import FilterBar from "../components/FilterBar";
import CONSTANTS from "../util/Constants";
import { ShrinkNumber } from "../util/Helper";
import ImageOrInitial from "../components/ImageOrInitial";
const queryString = require('query-string');


class BrokerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      broker:{},
      towers: [],
      activeTowers:[]
    };

    //document.title = "Home"
    SetChartDefaults(defaults);
}

componentDidMount() {
  getBroker(this.props.id).then((broker) => {
    this.setState({broker});
    AddRecent({type:"BROKER", id:this.props.id, name:broker.name, imageUrl:broker.imageUrl});
    getTowers(null, this.props.id, null).then((towers) => {
      if(towers && towers.length > 0){
        this.setState({towers, activeTowers:towers});  
      }
    });
  });
}

updateFilter = (e) =>{
  console.log(e.target.value);

  if(e.target.value){
    /****TODO can refine this */
    var activeTowers = this.state.towers.filter(tower => tower.company.name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1);
    this.setState({activeTowers});
  }
  else{
    this.setState({activeTowers:this.state.towers});
  }
}



  render() {
    /*
    const labels = [
      'AON : 0',
      'Retail : 10',
      'Client Services : 5',
      'Entertainment : 2',
      'Food : 20',
      'Other : 30',
    ];
    const data = {
      labels: labels,
      datasets: [{
        label: 'Industries',

        
        data: [0, 10, 5, 2, 20, 30],
      }]
    };

    const options = {
      elements:{
        arc:{
        },
      },
      plugins:{
        legend:{position:'right'}
      }
      
    }
    
    const stacked_data = {
      labels: [
        'AON',
        'Chubb',
        'Berkely Insurance Group',
        'Axis',
        'Navigators',
        'AIG',
        'Allianz',
      ],
      datasets: [
        {
          label: 'Primary',
          data: [1,2,1,0,1,0, 0],
          backgroundColor: CONSTANTS.COLORS.PURPLE,
          stack: 'Stack 0',
        },
        {
          label: 'Excess ABC',
          data: [1,2,3,5,0,10, 10],
          backgroundColor: CONSTANTS.COLORS.PURPLE_TRANSPARENT,
          stack: 'Stack 0',
        },
        {
          label: 'Lead Side A',
          data: [1,2,3,2,1,1, 0],
          backgroundColor: CONSTANTS.COLORS.RED,
          stack: 'Stack 0',
        },
        {
          label: 'Excess A',
          data: [1,2,3,2,1,1, 0],
          backgroundColor: CONSTANTS.COLORS.RED_TRANSPARENT,
          stack: 'Stack 0',
        },
      ]
    };

    var stacked_options = {
      scales: {
        x: {
          stacked: true,
        },
        y: {
          stacked: true
        }
      }
    };

    <div className="cardRow">
          
    <div className="card testDoughnut">
      <label className="chartTitle">Policies by Insurer</label>
      <Doughnut id="X" data={data} options={options} />
    </div>
    <div className="card testDoughnut">
      <label className="chartTitle">Premium by Insurer</label>
      <Doughnut id="X" data={data} options={options} />
    </div>
    <div className="card testDoughnut">
      <label className="chartTitle">Commission by Insurer</label>
      <Doughnut id="X" data={data} options={options} />
    </div>
    
  </div>
  <div className="cardRow">
    
      <div className="card testBar">
        <label className="chartTitle">Breakout by Insurer</label>
        <Bar id="Y" data={stacked_data} options={stacked_options} />
      </div>
  </div>
  <div className="cardRow">
    <div className="card testDoughnut">
      <label className="chartTitle">Insured by Industry</label>
      <Doughnut id="X" data={data} options={options} />
    </div>
    <div className="card testDoughnut">
      <label className="chartTitle">Insured by Sector</label>
      <Doughnut id="X" data={data} options={options} />
    </div>
    <div className="card testDoughnut">
      <label className="chartTitle">Insured by Market Cap</label>
      <Doughnut id="X" data={data} options={options} />
    </div>
  </div>
  */
    return (
      <div>
        <Header showHero title={this.state.broker.name}/>
        <div className="cardRow">
          <InfoCard title="Policy Count" value={this.state.broker.policyCount || 0}/>
          <InfoCard title="Total Premium" value={"$"+ShrinkNumber(this.state.broker.totalPremium)}/>
          <InfoCard title="Total Commission" value={"$"+ShrinkNumber(this.state.broker.totalCommission)}/>
        </div>
        <label className="sectionTitle">Towers</label>
        
        <FilterBar onUpdate={this.updateFilter} placeholderText="Filter towers by account name"/>

        <div className="card fullTable">
        {this.state.activeTowers.map((tower, index) => {
          
            return <a key={"account_"+tower.towerId} className="tableRow" href={"/accounts?id="+tower.company?.companyId}>
              <ImageOrInitial image={tower.company?.imageUrl} className="searchItemLogo" name={tower.company?.name} />
              <span  className="searchItemName">{tower.company?.name}</span>
              <span  className="searchItemSecondary"><b>${ShrinkNumber(tower.totalLimit)}</b> Limit</span>
            </a>
          
        })}

        
        </div>
      </div>
      
    );
  }
}
 
export default BrokerDetails;